import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'

import { routes } from 'constants/routes'
import { useCurrentUser } from 'hooks'
import { EOrganizationPlan } from 'types/enum'

type RequireChatManagementProps = {
  children: ReactNode
}

/**
 * ライトプラン（チャット管理なし）の組織ではチャット画面へのアクセスを拒否する
 */
export function RequireChatManagement({ children }: RequireChatManagementProps) {
  const { data: user, isLoading } = useCurrentUser()

  if (isLoading) {
    return null
  }

  if (user?.organizationPlan === EOrganizationPlan.LIGHT) {
    return <Navigate to={routes.HOME} replace />
  }

  return <>{children}</>
}
